<template>
  <router-btn v-if="!($route.query && $route.query.picker)" :text="$t('servicesystem.common_objects.article.add')"
    :icon="'mdi-plus'" :color="'quaternary'" :disabled="false" :outlined="false" :textbtn="textbtn" :large="large"
    :small="small" @Press="action">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "ArticlePickerBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$router.push({ query: { ...this.$route.query, picker: 'article' } });
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped></style>
